<template>
  <div>
    <!-- 题型1，大题下包含几个小题 -->
    <SubScale v-if="content.type==1" :content="content" v-on:listenToChildEvent="showMsg"></SubScale>
    <!-- 题型2，单选题-->
    <SelectRadio v-if="content.type==2" :content="content" v-on:listenToChildEvent="showMsg"></SelectRadio>
    <!-- 题型3，单选评分题 -->
    <RateScale v-if="content.type==3" :content="content" v-on:listenToChildEvent="showMsg"></RateScale>
    <!-- 题型4，联动题多选 -->
    <CheckBox v-if="content.type==4" :content="content" v-on:listenToChildEvent="showMsg"></CheckBox>
    <!-- 题型5，大题下面包含小题的文字题 -->
    <TextRadio v-if="content.type==5" :content="content" v-on:listenToChildEvent="showMsg"></TextRadio>
    <!-- 题型6 -->
    <TextInput v-if="content.type==6" :content="content" v-on:listenToChildEvent="showMsg"></TextInput>
  </div>
</template> <!--多答案-->
  <script>
    import SubScale from '../components/SubScale';
    import SelectRadio from '../components/SelectRadio'
    import RateScale from '../components/RateScale'
    import CheckBox from '../components/CheckBox'
    import TextRadio from '../components/TextRadio'
    import TextInput from '../components/TextInput'
      export default {
        props:{
          content: Object
        },
        components: {
          'SubScale': SubScale,
          'SelectRadio':SelectRadio,
          'RateScale':RateScale,
          'CheckBox':CheckBox,
          'TextRadio':TextRadio,
          'TextInput':TextInput
        },
        methods: {
          // 点击事件
          showMsg(index,num,type,s){
             this.$emit("listenToChildEvent", index, num, type, s);
          }
        }
      }
    </script>
    <style scoped>
    </style>
